<template>
<el-container id="home-main">
  <div class="home-center" style="text-align: center;height: 100vh;line-height:100vh;font-size: 30px;">
    HiBeds Home
  </div>
  <div style="position: absolute;top: 10px;right: 10px;">
    <a href="/portal/login">Go Login</a>
  </div>
</el-container>
</template>

<script scoped>
export default {
  name: 'Home',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  created: function () {},
  mounted: function () {},
  watch: {},
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods: {}
}
</script>
<style type="text/css" scoped>
</style>
<style lang="css">
/* .el-tooltip__popper{max-width:185px !important;} */
</style>



// WEBPACK FOOTER //
// src/components/Home.vue